<div class="order-return-item-table__wrapper">
  <table class="table table-borderless">
    <tr class="table__head-row">
      <th>Item(s)</th>
      <th>Description</th>
      <th class="text-center">Quantity</th>
      <th>Unit</th>
      <th *ngIf="isRestock">Location</th>
      <th *ngIf="isRestock">Lot</th>
      <th class="text-end" style="width: 180px">Unit Price</th>
      <th class="text-end" style="width: 10%">Line Total</th>
    </tr>
    <tbody>
      <tr
        *ngFor="
          let orderReturnItem of orderReturnItems;
          trackBy: trackById;
          let i = index
        "
      >
        <td>[{{ orderReturnItem.sku }}] {{ orderReturnItem.name }}</td>
        <td>{{ orderReturnItem.productDescription }}</td>
        <td class="text-center">{{ orderReturnItem.quantity }}</td>
        <td>{{ orderReturnItem.orderedUom?.name }}</td>
        <td *ngIf="isRestock">{{
          orderReturnItem.rfqStockLog?.location?.locationName
        }}</td>
        <td *ngIf="isRestock">{{
          orderReturnItem.rfqStockLog?.rfqLot?.lotNumber
        }}</td>
        <td class="text-end">{{ orderReturnItem.unitPrice | currency }}</td>
        <td class="text-end">{{
          orderReturnItem.quantity * orderReturnItem.unitPrice | currency
        }}</td>
      </tr>
      <tr class="border-0">
        <td [attr.colspan]="isRestock ? 6 : 4"></td>
        <td class="text-end"
          ><span class="text-cloud-500">Item Subtotal Refund:</span></td
        >
        <td class="text-end"
          ><strong>{{ itemSubtotalRefund | currency }}</strong></td
        >
      </tr>
      <tr class="border-0">
        <td [attr.colspan]="isRestock ? 6 : 4"></td>
        <td class="text-end"
          ><span class="text-cloud-500">Custom Refund Amount:</span></td
        >
        <td class="text-end"
          ><strong>{{ customRefundAmount | currency }}</strong></td
        >
      </tr>
      <tr class="border-0">
        <td [attr.colspan]="isRestock ? 6 : 4"></td>
        <td class="text-end"
          ><span class="text-cloud-500">Re-stocking Fee:</span></td
        >
        <td class="text-end"
          ><strong>{{ restockingFee | currency }}</strong></td
        >
      </tr>
      <tr class="border-0">
        <td [attr.colspan]="isRestock ? 6 : 4"></td>
        <td class="text-end"
          ><span class="text-cloud-500">Grand Total Refund:</span></td
        >
        <td class="text-end"
          ><strong>{{ grandTotalRefund | currency }}</strong></td
        >
      </tr>
      <tr class="border-0">
        <td [attr.colspan]="isRestock ? 6 : 4"></td>
        <td class="text-end"
          ><span class="text-cloud-500">Refund Item Quantity:</span></td
        >
        <td class="text-end"
          ><strong>{{ refundItemQuantity }}</strong></td
        >
      </tr>
      <tr>
        <td [attr.colspan]="isRestock ? 6 : 4"></td>
        <td class="text-end"><span class="text-cloud-500">Order Total:</span></td>
        <td class="text-end"
          ><strong>{{ orderTotal | currency }}</strong></td
        >
      </tr>
    </tbody>
  </table>
</div>
